// AUTO-CRM-32: CRM navigation, grouped like the Auto Appy sidebar (AUTO-319).
// Every destination is an existing page; old URLs keep working.

const starts = (...prefixes) => (pathname) => prefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));

// `can` receives { isAdmin, canManagePipelines, canManageLeadFields, canViewTeams }.
export const NAV_GROUPS = [
  {
    id: 'daily',
    items: [
      { id: 'home', label: 'Home', to: '/workspace', icon: 'home', match: starts('/workspace') },
      { id: 'leads', label: 'Leads', to: '/crm', icon: 'leads', match: (pathname) => starts('/crm', '/details', '/dashboard')(pathname) },
      { id: 'followups', label: 'Follow-ups', to: '/follow-ups', icon: 'followups', badge: 'due', match: starts('/follow-ups') },
      { id: 'targets', label: 'Targets', to: '/targets', icon: 'targets', match: starts('/targets') },
      { id: 'insights', label: 'Insights', to: '/insights', icon: 'insights', match: starts('/insights') },
    ],
  },
  {
    id: 'work',
    label: 'Work',
    items: [
      { id: 'documents', label: 'Documents', to: '/documents', icon: 'documents', match: starts('/documents') },
      { id: 'team', label: 'Team', to: '/teams', icon: 'team', match: starts('/teams', '/team'), can: (access) => access.canViewTeams },
    ],
  },
  {
    id: 'setup',
    label: 'Setup',
    items: [
      { id: 'pipelines', label: 'Pipelines', to: '/admin/pipelines', icon: 'pipelines', match: starts('/admin/pipelines', '/admin/pipeline', '/admin/workflow'), can: (access) => access.canManagePipelines },
      { id: 'leadtable', label: 'Lead table', to: '/admin/lead-fields', icon: 'leadtable', match: starts('/admin/lead-fields'), can: (access) => access.canManageLeadFields },
    ],
  },
];

export const FOOTER_ITEMS = [
  { id: 'settings', label: 'Settings', to: '/settings', icon: 'settings', match: starts('/settings', '/api-keys') },
];

export function visibleGroups(access) {
  return NAV_GROUPS
    .map((group) => ({ ...group, items: group.items.filter((item) => !item.can || item.can(access)) }))
    .filter((group) => group.items.length > 0);
}

export function activeItemId(pathname) {
  for (const group of NAV_GROUPS) {
    const found = group.items.find((item) => item.match(pathname));
    if (found) return found.id;
  }
  const footer = FOOTER_ITEMS.find((item) => item.match(pathname));
  return footer ? footer.id : null;
}

export function accessFor(currentUser) {
  const isAdmin = Boolean(currentUser?.is_admin);
  const permissions = currentUser?.permissions || [];
  return {
    isAdmin,
    canManagePipelines: isAdmin || permissions.includes('pipeline.manage'),
    canManageLeadFields: isAdmin || permissions.includes('lead-fields.manage'),
    canViewTeams: isAdmin || currentUser?.workspace_role === 'manager',
  };
}
